module.exports = __webpack_public_path__ + "img/IconaPDF_Color.06db5a1b.svg";